import SecondShoppingList from './SecondShoppingList';

export default SecondShoppingList;
